// extracted by css-extract-rspack-plugin
export default {"header":"_3_KG4"};